'use client';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import React, { AllHTMLAttributes } from 'react';

import CircularProgress from './CircularProgress';

import S from './LoadingCircle.module.scss';

export interface LoadingCircleProps extends AllHTMLAttributes<HTMLDivElement> {
  progress?: number;
  onAnimationComplete: () => void;
}

const LoadingCircle: React.FC<LoadingCircleProps> = ({
  progress = 0,
  className,
  onAnimationComplete,
  ...rest
}) => {
  return (
    <div className={clsx(S.CircleWrapper, className)} {...rest}>
      <AnimatePresence mode="wait">
        {progress !== 100 && (
          <>
            <motion.div
              className={clsx(S.DashedCircle)}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5, ease: 'easeInOut' }}
              onAnimationComplete={onAnimationComplete}
            />
            <CircularProgress />
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LoadingCircle;
